module.exports = __webpack_public_path__ + "static/img/slide_7_fr.7a53d10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_7_fr.svg
// module id = C5vE
// module chunks = 0